module.exports = __webpack_public_path__ + "static/media/car-wheel.1030d591.svg";